<template>
    <div class="wrapper">
        <el-tabs style="height: 100%" type="card"  v-model="activeName">
            <el-tab-pane  label="随访表单模板" name="form">
                <el-table
                    :data="formTemplateList"
                    stripe
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    style="width: 100%"
                >
                    <!-- <el-table-column
                            prop="id"
                            label="id"
                            width="100"
                    >
                    </el-table-column> -->
                    <el-table-column
                            prop="name"
                            label="名称"
                            width="200px"
                            sortable
                    >
                    </el-table-column>
                    <el-table-column
                            prop="description"
                            label="描述"
                            width="200px"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="note"
                            label="备注"
                            width="200px"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="create_time"
                            label="创建时间"
                            width="200px"
                            sortable
                    >
                        <template slot-scope="scope">
                            <span>{{filtersMoment(scope.row.create_time)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="update_time"
                        label="更新时间"
                        width="200px"
                        sortable
                    >
                    <template slot-scope="scope">
                        <span>{{filtersMoment(scope.row.update_time)}}</span>
                    </template>
                    </el-table-column>
                    <el-table-column
                            prop="creator"
                            label="创建者"
                            width="200px"
                            sortable
                    >
                    </el-table-column>            
                    <el-table-column
                            fixed="right"
                            label="操作"
                    >
                        <template slot-scope="scope">
                            <el-button @click="checkDetail(scope.row)" type="text" size="small">查看</el-button>
                            <el-button  @click="updateTemplate(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button  @click="deleteTemplate(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="this.pageNumber1"
                        :page-size="this.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="this.pageTotal1">
                </el-pagination>


                    <el-input
                            placeholder="测试：输入任务ID"
                            v-model="taskId">
                    </el-input>
                    <el-button type="primary" @click="jumpFollowupForm">填写问卷</el-button>


            </el-tab-pane>

            <el-tab-pane  label="提醒消息模板" name="notification">
            
                <el-table
                    :data="notificationTemplateList"
                    stripe
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    style="width: 100%"
                >
                    <!-- <el-table-column
                            prop="id"
                            label="id"
                            width="100"
                    >
                    </el-table-column> -->
                    <el-table-column
                            prop="name"
                            label="名称"
                            width="200"
                            sortable
                            >
                    </el-table-column>
                    <el-table-column
                            prop="description"
                            label="描述"
                            width="200"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="content"
                            label="内容"
                            width="200"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="note"
                            label="备注"
                            width="200"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="create_time"
                            label="创建时间"
                            width="200px"
                            sortable
                    >
                        <template slot-scope="scope">
                            <span>{{filtersMoment(scope.row.create_time)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="update_time"
                        label="更新时间"
                        width="200px"
                        sortable
                    >
                    <template slot-scope="scope">
                        <span>{{filtersMoment(scope.row.update_time)}}</span>
                    </template>
                    </el-table-column>
                    <el-table-column
                            prop="creator"
                            label="创建者"
                            width="200px"
                            sortable
                    >
                    </el-table-column>                     
                    <el-table-column
                            fixed="right"
                            label="操作"
                    >
                        <template slot-scope="scope">
                            <el-button @click="checkDetail(scope.row)" type="text" size="small">查看</el-button>
                            <el-button  @click="updateTemplate(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button  @click="deleteTemplate(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="this.pageNumber2"
                        :page-size="this.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="this.pageTotal2">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>


        <el-dialog :center="true" :fullscreen="true" title="预览" :visible.sync="dialogVisible">
            <el-switch
                    @change="switchPlateform"
                    v-model="IsPCPlateform"
                    active-color="#13ce66"
                    active-text="PC端"
                    inactive-text="手机端"
                    inactive-color="rgb(0, 126, 255)">
            </el-switch>
            <div v-if="IsPCPlateform == false" style="width:475px;height:797px;background: url(../iphone6.png);background-repeat: no-repeat;background-size:475px 797px; margin: 0 auto;">
                <div class="myformMaking" style="width: 378px; height: 577px;position: relative; top: 108px;overflow-y:auto;left: 49px;background-color: #ffffff">
                    <fm-generate-form
                            :data="jsonData"
                            :remote="remoteFuncs"
                            :value="values"
                            ref="generateForm">
                    </fm-generate-form>
                </div>
            </div>
            <div v-if="IsPCPlateform == true">
                <div style="background-color: #ffffff;height: 700px;margin-top: 15px;overflow-y:auto;">
                    <fm-generate-form
                            :data="jsonData"
                            :remote="remoteFuncs"
                            :value="values"
                            ref="generateForm">
                    </fm-generate-form>
                </div>

            </div>
        </el-dialog>
    </div>
</template>

<script>
    // import 'form-making/dist/FormMaking.less'
    import moment from '../../node_modules/moment/src/moment.js';
    import gql from 'graphql-tag';
    export default {
        name: '',
        data() {
            return {
                formTemplateList:[],  // 随访表单
                notificationTemplateList:[], // 提醒消息
                
                activeName:'form',

                IsPCPlateform:true,
                jsonData:{},
                jsonDataList:[
                    {
                        name:'22',
                        data:{
                            "list": [
                                {
                                    "type": "time",
                                    "icon": "icon-time",
                                    "options": {
                                        "defaultValue": "",
                                        "readonly": false,
                                        "disabled": false,
                                        "editable": true,
                                        "clearable": true,
                                        "placeholder": "",
                                        "startPlaceholder": "",
                                        "endPlaceholder": "",
                                        "isRange": false,
                                        "arrowControl": true,
                                        "format": "HH:mm:ss",
                                        "required": false,
                                        "width": "",
                                        "remoteFunc": "func_1581265391000_46974"
                                    },
                                    "name": "时间选择器",
                                    "key": "1581265391000_46974",
                                    "model": "time_1581265391000_46974",
                                    "rules": []
                                },
                                {
                                    "type": "rate",
                                    "icon": "icon-pingfen1",
                                    "options": {
                                        "defaultValue": 0,
                                        "max": 5,
                                        "disabled": false,
                                        "allowHalf": false,
                                        "required": false,
                                        "remoteFunc": "func_1581265392000_30867"
                                    },
                                    "name": "评分",
                                    "key": "1581265392000_30867",
                                    "model": "rate_1581265392000_30867",
                                    "rules": []
                                },
                                {
                                    "type": "slider",
                                    "icon": "icon-slider",
                                    "options": {
                                        "defaultValue": 0,
                                        "disabled": false,
                                        "required": false,
                                        "min": 0,
                                        "max": 100,
                                        "step": 1,
                                        "showInput": false,
                                        "range": false,
                                        "width": "",
                                        "remoteFunc": "func_1581265394000_23813"
                                    },
                                    "name": "滑块",
                                    "key": "1581265394000_23813",
                                    "model": "slider_1581265394000_23813",
                                    "rules": []
                                }
                            ],
                            "config": {
                                "labelWidth": 100,
                                "labelPosition": "right",
                                "size": "small"
                            }
                        }
                    }
                ],

                values: {}, // 表单需要显示的表单数据
                remoteFuncs: {
                    // 组件配置时配置的远端方法,保持和配置时输入的名称一致
                    func_test (resolve) {
                        // 模拟接口请求
                        setTimeout(() => {
                            const options = [
                                {id: '1', name: '1111'},
                                {id: '2', name: '2222'},
                                {id: '3', name: '3333'}
                            ]

                            // 获取到的值和标签可以通过配置页远端配置
                            // 值:id  标签：name
                            resolve(options) // 将后端获取的数据放入回调函数中
                        }, 2000)
                    },

                },
                templateValue:"",
                dialogVisible:false,
                pageNumber1: 1, // 随访表单 
                pageNumber2: 1, // 提醒消息
                pageSize: 15,
                pageTotal1: 0, // 随访表单总页数
                pageTotal2: 0, // 提醒消息总页数
   
                requestParams:
                `
                count
                data{
                    id
                    leader_id
                    doctor_id
                    name
                    type
                    description
                    from
                    content
                    note
                    create_time
                    update_time
                }`,

                taskId: -1, // 测试用，跳转到输入的任务ID

            }
        },
        methods: {
            changeTabMethod(tab, event){
                console.log(tab, event)
            },
            filtersMoment(time) {
                return (moment(time).format('YYYY-MM-DD HH:mm:ss'));
            },
            switchPlateform(val){
                console.log(val)
            },
           async deleteTemplate(row){

               this.$confirm('此操作将永久删除该模板, 是否继续?', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
               }).then(async() => {
                   try {
                       await this.$apollo.mutate({
                           mutation: gql`mutation(
                                      $id: Int!
                                    ){
                                      removeTemplate(
                                        id: $id
                                      )
                                    }`,
                           variables: {
                               id: row.id
                           },
                       });
                       this.$message({
                           message: "删除成功!",
                           type: "success"
                       });

                       this.pageNumber = 1;
                       this.pageSize = 10
                       this.init();
                   }catch (e) {
                       this.$message.error(e.message.split(":")[1]);
                   }
               }).catch((err) => {
                   console.log(err)
               });


            },
            // 编辑表单，跳转到新页面
            updateTemplate(row){
                this.$router.push({
                    name: 'templateSetting',
                    params:{template:row}
                });
            },
            // 预览模板
            checkDetail(row){
                try {
                    this.jsonData = JSON.parse(row.content)
                    this.dialogVisible = true;
                }catch (e) {
                    this.$message.error("请确认正确的模板格式");
                }
            },

            // 切换页面
            async handleCurrentChange(val) {
                if(this.activeName=="form"){
                    this.pageNumber1 = val;
                    this.formTemplateList = await this.getList("form");
                    console.log("In myTemplate.vue, handleCurrentChange, get templateInfo of 随访表单:", this.formTemplateList);
                }else if(this.activeName=="notification"){
                    this.pageNumber2 = val;
                    this.notificationTemplateList = await this.getList("notification");
                    console.log("In myTemplate.vue, handleCurrentChange, get templateInfo of 提醒消息:", this.notificationTemplateList);
                }
            },



           async getList(type){
                let response = {};
                if(type === "form"){
                    response = await this.$apollo.query({
                            query: gql`query($page_number: Int, $page_size: Int, $type: String){
                                        templateInfo(page_number: $page_number, page_size:$page_size, type:$type) {
                                            ${this.requestParams}
                                        }
                                    }`,
                            fetchPolicy: "no-cache",
                            variables: {
                                page_number: this.pageNumber1,
                                page_size: this.pageSize,
                                type: "随访表单"
                            },
                        });
                } else if(type === "notification"){
                    response = await this.$apollo.query({
                            query: gql`query($page_number: Int, $page_size: Int, $type: String){
                                        templateInfo(page_number: $page_number, page_size:$page_size, type:$type) {
                                            ${this.requestParams}
                                        }
                                    }`,
                            fetchPolicy: "no-cache",
                            variables: {
                                page_number: this.pageNumber2,
                                page_size: this.pageSize,
                                type: "提醒消息"
                            },
                        });                   
                }
                if(response.data.templateInfo.data.length>0){
                    for(let item of response.data.templateInfo.data){
                        if(item.from==='0'){
                            item.creator = "系统内置";   
                        }else{
                            let res = await this.$apollo.query({
                                query: gql`query($id: Int!){
                                            doctor(id: $id) {
                                                username
                                            }
                                        }`,
                                variables: {
                                    id: item.doctor_id
                                },
                            });
                            item.creator = res.data.doctor.username;
                        }
   

                }
            }
            return response.data.templateInfo;
           },

           async init(){
                let res = await this.getList("form");
                this.formTemplateList = res.data;
                this.pageTotal1 = res.count;
                res = await this.getList("notification");   
                this.notificationTemplateList = res.data;
                this.pageTotal2 = res.count;
                console.log("In myTemplate.vue, get templateInfo of 提醒消息:", this.notificationTemplateLis);
                console.log("In myTemplate.vue, get templateInfo of 随访表单:", this.formTemplateList);             
            },

            jumpFollowupForm(){
                this.$router.push({
                    name: 'followupForm',
                    params: {taskId:this.taskId}
                });
            }

        },
        mounted() {
           this.init();
        }
    }
</script>
<!--<style lang="less" scoped>
    @import '../assets/style/FormMaking.less';
</style>-->

<style lang="less" scoped>
    .wrapper {
        width: 100%;
        height: calc(100% - 40px);

        .item {
            margin-top: 20px;
        }

        .item-head {
            display: flex;
            height: 36px;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #55a9c6;

            .til {
                color: #47a2bf;
                padding-left: 5px;
                font-size: 14px;
                font-weight: bold;
            }

            .save-btn {
                width: 80px;
                height: 20px;
                color: #fff;
                border-radius: 5px;
                background-color: #47a2bf;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
                cursor: pointer;
            }
        }

        .parameter-list {
            .list-item {
                padding-left: 5px;
                margin-top: 10px;

                .list-til {
                    display: inline-block;
                    width: 100px;
                    font-size: 14px;
                    font-weight: bold;
                }

                input {
                    width: 270px;
                    height: 30px;
                    border: 1px solid #bbb;
                    border-radius: 5px;
                    text-indent: 10px;
                    outline: none;
                }
            }
        }
    }
</style>
